import React from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from 'tss-react/mui';
import {FormattedMessage, injectIntl} from 'react-intl';

const GeneralThankYou = (props) => {
  const {classes} = props;
  return (
    <div className={classes.div}>
      <FormattedMessage tagName='div' id='thankYouSms.thankYou'/>
    </div>
  );
};

const useStyles = theme => ({
  div: {
    alignItems: 'center',
    color: theme.palette.secondary.main,
    display: 'flex',
    fontSize: theme.typography.pxToRem(70),
    fontWeight: 'bold',
    height: '50vh',
    justifyContent: 'center',
    textAlign: 'center',

  },
});

//   innerBreadcrumbs: {
//     [theme.breakpoints.up(769)]: {display: 'none'},
//     '& .MuiStepper-root': {
//       marginBottom: 16,
//       padding: 0,
//       position: 'relative',
//     },
//   },
//   mainCarTooltip: {
//     [theme.breakpoints.up(1550)]: {marginLeft: 20},
//     '& .icon': {height: 42},
//   },
//   mainCarTooltipBubble: {
//     maxWidth: 220,
//   },
//   newClients: {
//     margin: '5px 0 20px',
//     [theme.breakpoints.down(768)]: {margin: '5px 16px 20px'},
//   },
//   noOffers: {
//     '& .contact_us_loader': {
//       margin: '30px 70px',
//     },
//     '& .img-container': {
//       '& img': {
//         maxWidth: 478,
//         width: '100%',
//       },
//       marginTop: 50,
//     },
//     '& .text': {
//       color: theme.palette.text.secondary,
//       fontSize: theme.typography.pxToRem(21),
//     },
//     '& button': {
//       display: 'flex',
//       fontWeight: 700,
//       justifyContent: 'space-between',
//       marginTop: 30,
//     },
//     padding: 10,
//   },
//   offersStep: {
//     margin: '0 auto',
//     maxWidth: 1180,
//   },
//   offersStepOffers: {
//     '&>*:not(:last-child)': {
//       marginBottom: 15,
//     },
//     backgroundColor: theme.palette.background.default,
//     borderRadius: 12,
//     [theme.breakpoints.down(768)]: {
//       backgroundColor: 'transparent',
//       borderRadius: 0,
//       padding: '15px 0',
//     },
//     padding: 15,
//   },
//   summaryText: {
//     [theme.breakpoints.down(768)]: {
//       '& .bg': {
//         background: theme.palette.mode === 'light' ?
//           'linear-gradient(180deg, #ECF9FE 0%, #FBFEFF 180px, #FFFFFF52 200px) 0% 0% no-repeat padding-box' :
//           'linear-gradient(180deg, #272733 0%, #3b3b42 180px, #424242 200px) 0% 0% no-repeat padding-box',
//         height: '200px',
//         pointerEvents: 'none',
//         position: 'absolute',
//         right: -26,
//         top: -16,
//         width: '100vw',
//         zIndex: -1,
//       },
//       '& > span': {fontWeight: 700},
//       fontSize: theme.typography.pxToRem(20),
//       fontWeight: 500,
//       letterSpacing: '-0.5px',
//       lineHeight: 1.2,
//       margin: '0 16px',
//       position: 'relative',
//       top: -16,
//       zIndex: 0,
//     },
//     color: theme.palette.secondary.main,
//     fontSize: theme.typography.pxToRem(24.5),
//     fontWeight: 600,
//     margin: '0 16px',
//     [theme.breakpoints.up(769)]: {margin: 0},
//   },
//   SummaryTitles: {
//     '& .handelingFeeIcon': {
//       marginRight: '5px',
//     },
//     '& h5': {
//       color: theme.palette.text.secondary,
//       display: 'flex',
//       fontSize: theme.typography.pxToRem(14),
//       fontWeight: 500,
//       lineHeight: 1.43,
//       margin: '5px 0',
//     },
//     '& img': {
//       height: '1.43em',
//       marginLeft: '5px',
//       width: 'auto',
//       zIndex: 1,
//     },
//     [theme.breakpoints.down(768)]: {
//       '& h5': {
//         fontSize: theme.typography.pxToRem(14),
//         margin: '0 16px',
//       },
//       marginBottom: 16,
//       position: 'relative',
//     },
//   },
//   withTooltip: {
//     margin: [[0, 0, 10, 0]],
//   },

export default withRouter(withStyles(injectIntl(GeneralThankYou), useStyles));
